import logger from '../utils/logger';

/**
 * Configuration centralisée de l'application
 */

// @ts-ignore - Vite injecte import.meta.env
const env = import.meta.env;

// API Backend URL - Utilise la variable d'environnement ou fallback intelligent
// Détection mode dev: vérifier si on est sur localhost OU si env.DEV est true
const isLocalDev = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' ||
   env.DEV === true);

// FORCER localhost si on est en localhost, même si VITE_API_URL est défini
export const API_URL = isLocalDev 
  ? 'http://localhost:3000'
  : (env.VITE_API_URL || 'https://clairifybackendaqetdhg6-container-nostalgic-swanson.functions.fnc.fr-par.scw.cloud');

// Log l'URL utilisée au démarrage
if (typeof window !== 'undefined') {
  logger.log(`[Config] API_URL détectée: ${API_URL} (${isLocalDev ? 'LOCAL DEV' : 'PRODUCTION'})`);
  logger.log(`[Config] Hostname: ${window.location.hostname}, env.DEV: ${env.DEV}`);
}

// Frontend URL - TOUT sur clairify.fr maintenant
export const APP_URL = env.VITE_APP_URL || 
 (isLocalDev
 ? 'http://localhost:5173'
 : 'https://clairify.fr');

// Supabase
export const SUPABASE_URL = env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = env.VITE_SUPABASE_ANON_KEY;

// Stripe
export const STRIPE_PUBLISHABLE_KEY = env.VITE_STRIPE_PUBLISHABLE_KEY;

// SÉCURITÉ #15: ANTHROPIC_API_KEY ne doit JAMAIS être exposé côté frontend!
// SUPPRIMÉ: Les appels Claude se font UNIQUEMENT depuis le backend
// Si vous avez besoin d'appeler Claude depuis le frontend, passez par une route API backend
// export const ANTHROPIC_API_KEY = env.VITE_ANTHROPIC_API_KEY; // DANGEREUX!

// Environment
export const IS_PRODUCTION = !isLocalDev && env.PROD;
export const IS_DEVELOPMENT = isLocalDev || env.DEV;

// Helper pour logger uniquement en dev
export const devLog = (...args: any[]) => {
 if (IS_DEVELOPMENT) {
 logger.log(...args);
 }
};

export const devError = (...args: any[]) => {
 if (IS_DEVELOPMENT) {
 logger.error(...args);
 }
};

export const devWarn = (...args: any[]) => {
 if (IS_DEVELOPMENT) {
 logger.warn(...args);
 }
};

// Logging helper pour la config
export const logConfig = () => {
 if (IS_DEVELOPMENT) {
 logger.log(' Config:', {
 API_URL,
 APP_URL,
 SUPABASE_URL,
 IS_PRODUCTION,
 ENV: env.MODE
 });
 }
};

// Filtrer TOUS les logs spam (GoTrueClient, Auth, Realtime, etc.)
if (typeof window !== 'undefined') {
  const originalLog = console.log;
  const originalWarn = console.warn;
  const originalInfo = console.info;

  console.log = (...args: any[]) => {
    const msg = String(args[0] || '');
    const fullMsg = args.join(' ');
    
    // LOGS BIG DATA : Toujours afficher en dev
    if (msg.includes('[BigData') || msg.includes('[Upload') || msg.includes('[Backend') || msg.includes('BIG DATA')) {
      return originalLog(...args);
    }
    
    // Liste complète des patterns à filtrer
    const spamPatterns = [
      'GoTrueClient',
      '#_acquireLock',
      '#_useSession',
      '#__loadSession',
      '#_autoRefreshTokenTick',
      '#_recoverAndRefresh',
      '#_handleVisibilityChange',
      '#_onVisibilityChanged',
      '#_stopAutoRefresh',
      '#_startAutoRefresh',
      '#_initialize',
      '#_notifyAllSubscribers',
      '#_saveSession',
      '#getSession()',
      'lock acquired',
      'lock released',
      'lock not available',
      'session from storage',
      'session has not expired',
      'INITIAL_SESSION callback',
      '[LOG]  [IndexedDB]',
      '[LOG]  [DataManager]',
      '[LOG]  [Realtime]',
      '[LOG]  [Phoenix]',
      '[LOG]  [Cache]',
      '[LOG] [AuthProvider]',
      '[LOG] [DomainRouter]',
      '[LOG] [HomePage]',
      '[LOG] [Studio]',
      '[LOG] [Session]',
      '[LOG] [App]',
      '[LOG] [loadChatSessions]',
      '[LOG] [loadProfile]',
      '[LOG] [IndexedDB]',
      'Cache HIT profiles',
      'Cached profiles',
      'Profile changed',
      'FluidChat: Chargement',
      '📋 FluidChat',
      '🔄 FluidChat',
      '[Resilience]',
      '[Login]',
      '[Heartbeat]',
      'Background analysis',
      'Resilience utilities',
      'Autoplay autorisé',
      'Update available',
      'periodic polling',
      'Session fetched',
      'Updating session',
      'Auth Check',
      'REDIRECT to studio',
      'Démarrage heartbeat',
    ];

    // Vérifier si le message contient un pattern spam
    const isSpam = spamPatterns.some(pattern => fullMsg.includes(pattern));
    
    if (isSpam) {
      return; // Bloquer le log
    }
    
    originalLog.apply(console, args);
  };

  console.warn = (...args: any[]) => {
    const msg = String(args[0] || '');
    const fullMsg = args.join(' ');
    
    // Patterns warning à filtrer - MODE SILENCIEUX
    const spamWarnings = [
      'GoTrueClient',
      '[WARN]', '[loadProfile]', '[AuthProvider]',
      '[HomePage]', '[Cache]', '[Phoenix]', '[Resilience]',
      'Quick timeout', 'COMPONENT FUNCTION CALLED',
      'Timeout after', 'Using DataManager',
    ];

    const isSpam = spamWarnings.some(pattern => fullMsg.includes(pattern));
    
    if (isSpam) {
      return; // Bloquer le warning
    }
    
    originalWarn.apply(console, args);
  };

  console.info = (...args: any[]) => {
    const msg = String(args[0] || '');
    // Filtrer tous les info GoTrueClient
    if (msg.includes('GoTrueClient')) {
      return;
    }
    originalInfo.apply(console, args);
  };
}

// DEBUG: RÉACTIVATION TEMPORAIRE DES LOGS EN PRODUCTION
// TODO: DÉSACTIVER CES LOGS APRÈS LE DEBUG !
if (IS_PRODUCTION) {
 // LOGS ACTIVÉS TEMPORAIREMENT POUR DEBUG
 // console.log = () => {};
 // console.warn = () => {};
 // console.info = () => {};
 // console.debug = () => {};
 // Garder console.error pour les vraies erreurs critiques
 
 logger.warn(' ATTENTION: Console logs ACTIVÉS en production pour debug !');
}

